export const linksligasc = [
    {
        "nombre" : "Comites y Consejos",
        "link" : "/Acciones",
        "submenu" : [
            {
                "subMenuNombre" : "Uiimh",
                "subMenuUrl" : "/Uiimh"
            }
        ]
    }
]